import { IEmailContaGrupoVinculo } from "../../../Interfaces/Geral/Grupos/GruposEmailsInterfaces";

import {
    DesvincularEmailContaGrupoService,
    VincularEmailContaGrupoService,
    ListarEmailContaVinculadosPorGrupoService,
    ListarEmailContaNaoVinculadosPorGrupoService,
    ListarEmailContaPorUsuarioService,
} from "../../../Services/Geral/Grupos/GruposEmailsService";

import { Controller } from "../../Controller";

export async function DesvincularEmailContaGrupoController(
    IDEmailContaGrupo: number
) {
    return Controller(DesvincularEmailContaGrupoService(IDEmailContaGrupo));
}

export async function VincularEmailContaGrupoController(
    requestBody: IEmailContaGrupoVinculo
) {
    return Controller(VincularEmailContaGrupoService(requestBody));
}

export async function ListarEmailContaVinculadasPorGrupoController(
    IDGrupo: number
) {
    return Controller(ListarEmailContaVinculadosPorGrupoService(IDGrupo));
}

export async function ListarEmailContaNaoVinculadasPorGrupoController(
    IDGrupo: number
) {
    return Controller(ListarEmailContaNaoVinculadosPorGrupoService(IDGrupo));
}

export async function ListarEmailContaPorUsuarioController() {
    return Controller(ListarEmailContaPorUsuarioService());
}
